import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/despesaExecucao";

/**
 * Classe de gerenciamento de chamadas da API dos Despesa Execucao
 *
 * @class
 */
export default class DespesaExecucaoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe DespesaExecucaoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns Lista de despesa execução
   */
    listarDespesaExecucao(codExecucao: number) {

        return this.api<ApplicationModule[]>(`${controller}/despesaexecucaolistar`, {
            method: "GET",
            params: { codExecucao }
        });
    }

    /**
   * @returns Lista de despesa execução
   */
    listar(codExecucao: number) {

        return this.api<ApplicationModule[]>(`${controller}/listar`, {
            method: "GET",
            params: { codExecucao }
        });
    }

     /**
   * @returns Lista de despesa execução
   */
     lerRegistro(codDespesaExecucao: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codDespesaExecucao }
        });
    }

}